// Based on reNgine.definitions.CELERY_TASK_STATUSES
// Use actual values if they matter, otherwise simple enum keys might suffice
export enum CeleryTaskStatus {
  PENDING = 0, // Example value, adjust as needed
  STARTED = 1,
  SUCCESS = 2,
  FAILURE = 3,
  RETRY = 4,
  REVOKED = 5,
  // Add other statuses based on your actual definition
  UNKNOWN = -1, // Match your default
}

// Based on reNgine.definitions.NUCLEI_REVERSE_SEVERITY_MAP
export enum VulnerabilitySeverity {
  UNKNOWN = -1,
  INFO = 0,
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
  CRITICAL = 4,
}

// Helper mapping (optional, useful for display)
export const VulnerabilitySeverityMap: { [key in VulnerabilitySeverity]: string } = {
  [VulnerabilitySeverity.UNKNOWN]: 'Unknown',
  [VulnerabilitySeverity.INFO]: 'Info',
  [VulnerabilitySeverity.LOW]: 'Low',
  [VulnerabilitySeverity.MEDIUM]: 'Medium',
  [VulnerabilitySeverity.HIGH]: 'High',
  [VulnerabilitySeverity.CRITICAL]: 'Critical',
};